export { BurgerCloser } from './burger-closer';
export type { BurgerCloserProps } from './models';
